import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useProductViewModel } from './viewmodels/product-viewmodel';
import { motion } from 'framer-motion';

// Components
import ProductImages from './components/ProductImages';
import ProductInfo, { MobileProductHeader } from './components/ProductInfo';
import ProductLoader from './components/ProductLoader';
import ProductAlert from './components/ProductAlert';
import RelatedProducts from './components/RelatedProducts';

// Layout components
import Navbar from '../../../components/Navbar'; 
import Footer from '../../../components/Footer';
import CartDrawer from '../../../components/CartDrawer';

const ProductPage = () => {
  const { id, depotid } = useParams();
  const { 
    product, 
    loading, 
    error,
    selectedVariant,
    quantity,
    activeImage,
    cartMessage,
    variantTypes,
    selectedVariantValues,
    handleVariantChange,
    handleVariantValueChange,
    handleQuantityChange,
    handleImageChange,
    handleAddToCart,
    closeCartMessage
  } = useProductViewModel(id, depotid);
  
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    if (product) {
      document.title = `${product.name} | Votre E-commerce`;
    } else {
      document.title = 'Détails du produit | Votre E-commerce';
    }
  }, [product]);
  
  if (error) {
    return (
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <div className="flex-grow pt-32 pb-16 px-4">
          <div className="container mx-auto text-center">
            <svg className="w-16 h-16 mx-auto text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <h2 className="mt-4 text-lg font-medium text-gray-900">Une erreur est survenue</h2>
            <p className="mt-2 text-gray-500">{error}</p>
            <button 
              onClick={() => window.location.reload()}
              className="mt-4 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#174540] hover:bg-[#0d2926]"
            >
              Réessayer
            </button>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
  
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow pt-32 pb-16">
        <div className="container mx-auto px-4">
          {loading ? (
            <ProductLoader />
          ) : (
            <>
              {/* Mobile Product Header - Shows only on mobile above images */}
              <MobileProductHeader 
                product={product} 
                selectedVariant={selectedVariant} 
              />

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {/* Product Images */}
                <ProductImages 
                  images={product.imageUrl}
                  activeImage={activeImage}
                  onImageChange={handleImageChange}
                  product={product}
                  selectedVariant={selectedVariant}
                />
                
                {/* Product Info */}
                <ProductInfo 
                  product={product}
                  selectedVariant={selectedVariant}
                  quantity={quantity}
                  onQuantityChange={handleQuantityChange}
                  onVariantChange={handleVariantChange}
                  onAddToCart={handleAddToCart}
                  variantTypes={variantTypes}
                  selectedVariantValues={selectedVariantValues}
                  onVariantValueChange={handleVariantValueChange}
                  onImageChange={handleImageChange}
                />
              </div>
              
              {/* Cart Message Alert */}
              <ProductAlert 
                message={cartMessage.message} 
                type={cartMessage.type} 
                show={cartMessage.show}
                onClose={closeCartMessage}
              />
            </>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ProductPage;